import { render, staticRenderFns } from "./PosterAiGenerateTrigger.vue?vue&type=template&id=b1828d48&"
import script from "./PosterAiGenerateTrigger.vue?vue&type=script&lang=js&"
export * from "./PosterAiGenerateTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports